module.exports = __webpack_public_path__ + "img/企修通用户端软著登记证书.ffed3f5d.png";